import TableConfigV3, {
    ColumnTypes,
} from "../../components/TableV3/TableV3Config";

const DeclarationListConfig: TableConfigV3 = {
    id: "uuid",
    columns: [
        {
            title: "Actions",
            dataIndex: "actions",
            type: ColumnTypes.Action,
            actions: [
                {
                    func: "edit",
                    display: {
                        text: "'Edit'",
                        icon: "edit",
                        condition: "#active",
                    },
                },
            ],
        },
        // {
        //     title: "Status",
        //     dataIndex: "status",
        //     type: ColumnTypes.Status,
        // },
        // {
        //     title: "Policy ID",
        //     dataIndex: "policyId",
        //     type: ColumnTypes.Number,
        // },
        // {
        //     title: "UUID",
        //     dataIndex: "uuid",
        //     type: ColumnTypes.String,
        // },
        {
            title: "Declaration Date",
            dataIndex: "declarationDateStr",
            // type: ColumnTypes.dd_mmm_yyyy,
            sorter: true,
        },
        {
            title: "Goods Value",
            dataIndex: "goodsValue",
            type: ColumnTypes.Money,
            sorter: true,
        },
        // {
        //     title: "Total Goods Value",
        //     dataIndex: "totalGoodsValue",
        //     type: ColumnTypes.Money,
        //     sorter: true,
        // },
        {
            title: "Remark",
            dataIndex: "remark",
            type: ColumnTypes.String,
        },
        {
            title: "Receiver Name",
            dataIndex: "receiverName",
            type: ColumnTypes.String,
        },
        {
            title: "Receiver Address",
            dataIndex: "receiverAddress",
            type: ColumnTypes.String,
        },
        {
            title: "Consignment Details",
            dataIndex: "consignmentDetails",
            type: ColumnTypes.String,
        },
        {
            title: "Sender Name",
            dataIndex: "senderName",
            type: ColumnTypes.String,
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            type: ColumnTypes.String,
        },
        {
            title: "Invoice Date",
            dataIndex: "invoiceDateStr",
            // type: ColumnTypes.dd_mmm_yyyy,
            sorter: true,
        },
        {
            title: "Transportation Mode",
            dataIndex: "transportationMode",
            type: ColumnTypes.String,
        },
        {
            title: "Transportation Number",
            dataIndex: "transportationNumber",
            type: ColumnTypes.String,
        },
        // {
        //     title: "Active",
        //     dataIndex: "active",
        //     type: ColumnTypes.Boolean,
        // },
    ],
};

export default DeclarationListConfig;
